export default __webpack_public_path__ + "static/media/walletconnect-circle.865c77e7.png";